package scroll

import kotlinx.browser.window
import rendering.CameraManager
import rendering.RendererManager
import util.DebugManager
import util.ScrollHelper
import util.ScrollIndicator

object ScrollManger {
    init {
        ScrollAnimator
    }

    private var lastProgress = -1.0
    private val startTimestamp = window.performance.now()
    private var lastTimestamp = window.performance.now()

    /**
     * Called every frame to render the specified [animation].
     *
     * For this, we fetch the current scroll progress/position and then check if it has changed since the last frame.
     * For XR devices, we always re-calculate stuff (otherwise this could lead to problems with XR-specific offsets
     * when enabling XR mode). On other devices, we only re-calculate stuff if the scroll progress has changed for
     * performance reasons.
     */
    fun render(animation: ScrollAnimation) {
        val dt = window.performance.now() - lastTimestamp
        lastTimestamp = window.performance.now() - startTimestamp
        RendererManager.render()
        CameraManager.responsiveZOffset()
        CameraManager.animate(lastTimestamp, dt)

        val progress = ScrollHelper.getScrollProgress()
        if (progress != lastProgress || RendererManager.renderer.xr.isPresenting) {
            lastProgress = progress
            handleNewProgress(animation, progress)
        }
    }

    private fun handleNewProgress(animation: ScrollAnimation, progress: Double) {
        ScrollIndicator.handle(progress)
        ScrollAnimator.animate(animation, progress)
        DebugManager.render()
    }
}